export var riskManagementResourceAdapter = function riskManagementResourceAdapter(riskManagement) {
    return riskManagement ? riskManagement : {
        use: false,
        stopSell: 0,
        buyMultiplier: 1,
        stepDown: 0,
        sellMultiplier: 1,
        percentageCover: 0,
        type: 0,
        percentageDown: 0,
        percentageUp: 0
    };
};
